import RequestToResetPassword from '@/services/auth/passwordService/RequestToResetPassword';
import RequestToUpdatePassword from '@/services/auth/passwordService/RequestToUpdatePassword';
import ValidateResetPasswordToken from '@/services/auth/passwordService/ValidateResetPasswordToken';

export default class PasswordService {
    /**
     * Send request for password reset.
     *
     * @param {String} email
     * @param {String} password
     * @param {String} confirmPassword
     * @param {String} token

     * @returns {Promise}
     */
    requestToUpdatePassword(email, password, confirmPassword, token) {
        return (new RequestToUpdatePassword()).handle(email, password, confirmPassword, token);
    }

    /**
     * Send the forgotten password email based on the email from the input.
     *
     * @param {String} email
     *
     * @returns {Promise}
     */
    requestToResetPassword(email) {
        return (new RequestToResetPassword()).handle(email);
    }

    /**
     * Validates the token to reset password.
     *
     * @param {String} token
     * @param {String} email
     *
     * @return {Promise}
     */
    validateResetPasswordToken(token, email) {
        return (new ValidateResetPasswordToken()).handle(token, email);
    }
}
